const styleOverrides = {
  contained: {
    marginLeft: 0,
    marginRight: 14
  }
};
export default {
  styleOverrides
};